import React, { useMemo } from 'react';

import { Group, Progress, Text, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

interface ICreditsProgressBarProps {
  creditsUsed: number;
  totalCredits: number | null;
  height?: string;
}

const CreditsProgressBar = ({
  creditsUsed,
  totalCredits,
  height = undefined,
}: ICreditsProgressBarProps): JSX.Element => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.sm}`, false);
  const creditsUsedInPercentage = useMemo(() => {
    if (creditsUsed === 0) {
      return 0;
    }
    if (totalCredits === null) {
      return 35;
    }
    return (creditsUsed / (totalCredits || 1)) * 100;
  }, [totalCredits, creditsUsed]);

  const isCreditsInfinity = totalCredits === null;

  return (
    <Group spacing='sm' noWrap align='center' h={height}>
      {isDesktop && (
        <Progress
          style={{ flexGrow: 1 }}
          radius='xl'
          size='xl'
          value={creditsUsedInPercentage}
          sections={[
            {
              value: creditsUsedInPercentage,
              color: 'kiloBlue',
            },
          ]}
        />
      )}
      <Text size='sm' color='dimmed' fs='italic' align='right'>
        {`${creditsUsed} / ${isCreditsInfinity ? '∞' : totalCredits}`}
      </Text>
    </Group>
  );
};

export default CreditsProgressBar;
